import reducer, { actions } from './slice';

export const openIdVerificationStore = {
  actions,
};

export default reducer;
